import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ACCESS_TIERS } from '../../config/constants';

const PremiumRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) return null;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!currentUser.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // userProfile loads async from Firestore — wait before checking subscription
  // to avoid a redirect flash while the profile is still arriving.
  if (!userProfile) {
    return null;
  }

  const tier = userProfile.subscription?.tier;
  const status = userProfile.subscription?.status;
  if (!ACCESS_TIERS.includes(tier) || !['active', 'trialing'].includes(status)) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

export default PremiumRoute;
